export default "__VITE_PUBLIC_ASSET__3b089e80__"